/**
 * Client-side contact info masking utilities.
 *
 * Used for masking Plivo SDK caller IDs in the browser (the only place
 * where real numbers bypass the backend masking layer).
 *
 * Backend API responses are already masked server-side — these functions
 * are only needed for client-side SDK events.
 */

export function maskPhone(number: string | null | undefined): string {
  if (!number) return number ?? ''
  const digits = number.replace(/\D/g, '')
  if (digits.length <= 4) return number
  const visible = digits.slice(-4)
  return '*'.repeat(digits.length - 4) + visible
}

export function maskEmail(email: string | null | undefined): string {
  if (!email || !email.includes('@')) return email ?? ''
  const [local, domain] = email.split('@')
  return `${local[0]}****@${domain}`
}
